import {FC, PropsWithChildren} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type PricingTableSectionProps = {
  title: string
}

export const PricingTableSection: FC<PropsWithChildren<PricingTableSectionProps>> = ({
  title,
  children,
}) => (
  <>
    <div className="wrapper">
      <div className="header">
        <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
          {title}
        </Text>
      </div>
      <ul className="list">{children}</ul>
    </div>

    <style jsx>{`
      .wrapper + .wrapper {
        margin-top: ${theme.spacing[7]};
      }
      .header {
        display: inline-block;
        padding: ${theme.spacing[3]} ${theme.spacing[6]};
        background-color: ${theme.palette.background.butterDark};
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }
      .list {
        padding: ${theme.spacing[3]} 0;
        position: relative;
        background-color: ${theme.palette.background.default};
        border: 1px solid ${theme.palette.gray[200]};
        border-radius: 16px;
        border-top-left-radius: 0;
      }
      @media ${MOBILE_SCREENSIZE} {
        .wrapper + .wrapper {
          margin-top: ${theme.spacing[5]};
        }
        .header {
          padding: ${theme.spacing[2]} ${theme.spacing[4]};
        }
        .list {
          padding: 0;
        }
      }
    `}</style>
  </>
)
